import axios from './axios'
import { getAccessToken } from '@/utils'

const ajax = {}
const methods = ['get', 'post', 'put', 'patch', 'delete']

methods.forEach((item) => {
  ajax[item] = async (url, data, headers) =>
    await axios[item](url, data, headers)
      .then((res) => res.data)
      .catch((err) => err)
})

/**
 * 短信验证码
 */
export const getPins = ({ mobile, type }) => ajax.post('/v1/mobile/pins', { mobile, type })

/**
 * 图片验证码
 */
export const getCaptchas = () => ajax.get('/v1/captchas')

/**
 * 卖家注册
 */
export const register = ({ mobile, pin, password, confirmation }) =>
  ajax.post('/v1/seller/register', {
    mobile,
    pin,
    password,
    password_confirmation: confirmation,
    type: 'register'
  })

/**
 * 卖家登录
 */
export const login = ({ username, password, captcha, key, remember }) =>
  ajax.post(
    '/v1/seller/login',
    key
      ? {
          username,
          password,
          captcha,
          key,
          remember
        }
      : {
          username,
          password,
          remember
        }
  )

/**
 * 退出登录
 */
export const logout = () => {
  ajax.post('/v1/seller/logout')
}

/**
 * 卖家验证码登录
 */
export const loginByPin = ({ mobile, pin, remember }) =>
  ajax.post('/v1/seller/login/mobile', {
    mobile,
    pin,
    remember,
    type: 'login'
  })

/**
 * 重置密码
 */
export const resetPassword = ({ mobile, pin, password, confirmation }) =>
  ajax.post('/v1/seller/password/reset', {
    mobile,
    pin,
    password,
    password_confirmation: confirmation,
    type: 'reset'
  })

/**
 * 获取当前用户入驻信息
 */
export const getSteps = (status) => ajax.get(`/v1/seller/steps/${status}`)

/**
 * 设置当前用户入驻信息
 */
export const setSteps = (status, formData, headers = {}) => {
  if (!('FormData' in window)) {
    return new Promise((resolve, reject) => {
      const formDom = document.createElement('form')
      const iframeDom = document.createElement('iframe')

      formDom.method = 'post'
      formDom.action = `/api/dev/v1/seller/steps/${status}?token=${getAccessToken()}`
      formDom.enctype = 'multipart/form-data'
      formDom.target = 'target'
      formDom.style.display = 'none'
      iframeDom.name = 'target'
      iframeDom.style.display = 'none'

      iframeDom.onload = () => {
        const data = JSON.parse(iframeDom.contentDocument.body.textContent)
        document.body.removeChild(formDom)
        document.body.removeChild(iframeDom)
        resolve(data)
      }

      iframeDom.onerror = () => {
        reject({})
      }

      formData.forEach((item) => {
        if (item.type === 'file') {
          formDom.appendChild(document.getElementById(item.name))
        } else {
          const inputDom = document.createElement('input')
          inputDom.type = item.type || 'hidden'
          inputDom.name = item.name
          inputDom.value = item.value
          formDom.appendChild(inputDom)
        }
      })

      document.body.appendChild(formDom)
      document.body.appendChild(iframeDom)
      formDom.submit()
    })
  } else {
    return ajax.post(`/v1/seller/steps/${status}`, formData, headers)
  }
}

/**
 * 获取地区信息-省
 */
export const getRegions = () => ajax.get('/v1/regions')

/**
 * 获取地区信息-市区镇
 */
export const getAreas = (id) => ajax.get(`/v1/regions/${id}`)

/**
 * 地区信息-省市区镇详情
 * longitude 经度
 * latitude 纬度
 */
export const getRegionsLocation = (longitude, latitude) => {
  const url = `/v1/region/geocoder/location?longitude=${longitude}&latitude=${latitude}`
  return ajax.get(url)
}

/**
 * 商品分类
 */
export const getCategories = () => ajax.get(`/v1/categories?exclude=1`)

/**
 * 卖家中心-当前登录用户信息
 */
export const getSeller = (show) => ajax.get(`/v1/seller${show === 0 ? '?show_welcome=0' : ''}`)
